export default "__VITE_ASSET__a9f9b976__"